/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2016, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 * Drag-and-Drop Manager
 */
define([], function() {


	const DnDHelper = {

		_id: null,

		/** Handles drag'n'drop for when the user drags a widget on to something that isn't the actual target, but rather
		 * is another page. Examples where it is used include when dragging a widget on to a frame in the filmstrip (for a story) or
		 * a tab in a tabbed dashboard.
		 * @param canvas - the canvasAPI
		 * @param parentId - The id (string) that the widget is dropped on to.
		 * @param dragObject - the widget being dragged.
		 */
		handleWidgetDrop: function(canvas, parentId, dragObject) {
			if (canvas) {
				if (dragObject.data.operation === 'new') {
					const widgetContent = this._prepareWidgetContent(parentId, dragObject);
					canvas.addContent(widgetContent);
				} else if (dragObject.data.operation === 'move') {
					const contentIdList = this._getContentIdList(dragObject);
					canvas.moveContent(parentId, contentIdList);
				}
			}
		},

		/** Prepares a drag'n'drop widget for 'blind' drops, such as when we drag a widget on to
		 * a frame in the film strip that isn't the currently selected one.
		 */
		_prepareWidgetContent: function(parentId, dragObject) {
			const layoutProperties = dragObject.data.layoutProperties.style || {};
			const widgetModel = dragObject.widgetSpec.model;
			const widgetContent = {
				containerId: parentId,
				layout: {
					...layoutProperties
				},
				type: `widget.${widgetModel.type}`,
				spec: {
					style: layoutProperties,
					...widgetModel
				}
			};
			return widgetContent;
		},

		_getContentIdList: function(dragObject) {
			const nodesInfoList = dragObject.data && dragObject.data.nodeInfoList;
			const contentIdList = nodesInfoList.map((nodesInfo)  => {
				if (nodesInfo && nodesInfo.node && nodesInfo.node._layout) {
					return	nodesInfo.node._layout.model && nodesInfo.node._layout.model.id;
				}
			});
			return contentIdList;
		}
	};

	return DnDHelper;
});
